export default "__VITE_ASSET__C5Ddu3eT__"